import styled, { css } from "styled-components";
import { getWallpaperBgColor, sliderToOpacity } from "../../utils/helpers";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { device } from "../../utils/device";

export const MainWrapper = styled.div`
  position: relative;
  min-width: 354px;
  width: 25vw;
  z-index: 300;
  overflow: hidden;

  @media (${device.mobilePortrait}) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100vw;
    /* height: 88dvh; */
    margin-top: ${({ segmentListOpen, fullView }) =>
      segmentListOpen ? "0px" : "-40px"};
    margin-bottom: 2vh;
    margin-bottom: 2dvh;
  }

  ${({ isMobilePortrait, segmentListOpen }) =>
    isMobilePortrait &&
    `
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      margin-top: ${segmentListOpen ? "0px" : "-40px"};
      width: 75vw;
    `}
`;

export const Container = styled.div`
  height: 85vh;
  height: ${(props) => props.height || "85dvh"};
  max-height: 900px;
  width: 100%;
  border: 1px solid ${({ color }) => color};
  border-left: 10px solid ${({ color }) => color};
  border-radius: 10px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  overflow: hidden;
  background: ${({
    currentBg,
    segmentBgColor,
    bgWallpaper,
    isPattern,
    wallpaperOverlayColor,
  }) => (currentBg === 3 ? segmentBgColor : "transparent")};

  @media ${device.mobilePortrait} {
    height: calc(100vh - 5vh - 60px - 45px);
    height: calc(100dvh - 7dvh - 60px - 45px);
  }

  @media ${device.xl} {
    height: calc(100vh - 5vh - 60px - 45px - 12vh);
    height: calc(100dvh - 7dvh - 60px - 45px - 12dvh);
    max-height: none;
  }

  background-color: ${({
    currentBg,
    segmentBgColor,
    bgWallpaper,
    isPattern,
    wallpaperOverlayColor,
  }) =>
    currentBg === 0 || currentBg === 3
      ? currentBg === 0
        ? segmentBgColor
        : bgWallpaper !== "" && isPattern
        ? getWallpaperBgColor(wallpaperOverlayColor)
        : currentBg === 3 && segmentBgColor === "transparent"
        ? "transparent"
        : "white"
      : "transparent"};
`;

export const BackgroundImageCover = styled.div`
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
  background-image: ${({ currentBg, bgWallpaper }) =>
    currentBg === 2 && bgWallpaper !== "" ? `url(${bgWallpaper})` : "none"};
  background-size: cover; /* Fit the image within the parent */
  background-repeat: no-repeat;
  background-position: center; /* Center the image */

  opacity: ${({ wallpaperTransparency }) =>
    sliderToOpacity(wallpaperTransparency)};
`;
export const PatternContainer = styled.div`
  position: absolute;
  z-index: -1;
  opacity: ${({ wallpaperTransparency }) =>
    sliderToOpacity(wallpaperTransparency)};
  height: 100%;
  width: 100%;
  background-repeat: repeat;
  border-bottom-right-radius: 10px;
  background: ${({ wallpaperOverlayColor }) => wallpaperOverlayColor};
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  z-index: 1;
  position: relative;
  opacity: 1;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  background-color: white;
  width: 100%;
  border-top-right-radius: 10px;
  display: flex;
  overflow: hidden;
  align-items: center;
  cursor: pointer;
  position: sticky;
  top: 0;
  z-index: 10;
  height: 45px;
`;

export const InnerContainer = styled.div`
  display: flex;
  width: 100%;
  background-color: ${({ color }) => getWallpaperBgColor(color, 0.3)};
  height: 100%;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
`;

export const StyledSettingsIcon = styled(SettingsOutlinedIcon)`
  margin-left: 10px;
`;

export const ScrollableContainer = styled.div`
  height: calc(85vh - 45px);
  height: calc(85dvh - 45px);

  ::-webkit-scrollbar {
    display: none;
  }
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain; /* Prevents bounce */
  position: relative;

  @media ${device.mobilePortrait} {
    max-height: calc(100vh - 5vh - 60px - 45px - 30px);
    max-height: calc(100dvh - 7dvh - 60px - 45px - 30px);
  }

  @media ${device.xl} {
    max-height: calc(100vh - 5vh - 60px - 45px - 30px - 12vh);
    max-height: calc(100dvh - 7dvh - 60px - 45px - 30px - 12dvh);
  }
`;

export const SegmentIcon = styled.div`
  height: 36px;
  width: 32px;
  background-color: ${({ color }) => color};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 12px;
  z-index: 2;
  left: -34px;
`;

export const Navigator = styled.div`
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  display: flex;
  height: 60px;
  display: -webkit-flex;
`;

export const IconView = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  background-color: white;
  width: 24px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: auto auto;
`;
